import { lazier } from '@shared/components';

import PersonProfilePagePlaceholder from './PersonProfilePagePlaceholder';

export { PersonProfilePagePlaceholder };

export const PersonProfilePage = lazier(
  () => import('./PersonProfilePage'),
  PersonProfilePagePlaceholder,
);
